<template>
  <div class="main-container">
    <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
    <div class="container">
      <BreadcrumbsHelper v-if="this.$store.state.auth.mUser.role === 'admin' || this.$store.state.auth.mUser.role === 'editor'" :breadcrumbs="this.breadcrumbs" />
    </div>
    <div class="container text-left">
      <div class="city-container">
        <h1 class="title">Cities</h1>
        <ul class="city-filter" aria-label="City Filter">
          <li
            @click="filterCities(letter)"
            v-for="(letter, index) in this.alphabet"
            :key="index"
            :class="{ selected: selectedLetter === letter, disabled: !doesLetterHaveCities(letter) }"
          >
            {{ letter }}
          </li>
        </ul>
        <div>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th class="clickable" @click="sortCities('name')">Name <font-awesome-icon icon="sort" /></th>
                <th style="width: 12rem" class="clickable" @click="sortCities('region')">Region <font-awesome-icon icon="sort" /></th>
                <th class="clickable" @click="sortCities('type')">City Type <font-awesome-icon icon="sort" /></th>
                <th class="clickable" @click="sortCities('updated')">Last Updated <font-awesome-icon icon="sort" /></th>
                <th style="width: 40%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="city in this.cities" :key="city.id">
                <td>
                  <router-link :to="{ name: 'city detail', params: { cityId: city._id } }">{{ city.name }}</router-link>
                </td>
                <td>{{ city.region }}</td>
                <td>{{ getCityTypeDisplay(city.city_type) }}</td>
                <td>{{ new Date(city.updated_at).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' }) }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';

export default {
  components: {
    Loading,
    BreadcrumbsHelper,
  },
  async created() {
    try {
      this.isLoading = true;
      this.setBreadcrumbs();
      await this.$store.dispatch('cities/getCities');
      this.cities = this.$store.state.cities.cities;
      this.allCities = this.cities;
      this.selectedLetter = 'ALL';
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
  data() {
    return {
      isLoading: false,
      sortProperty: 'name',
      sortOrder: 1,
      selectedLetter: '',
      sortFunction: undefined,
      breadcrumbs: [],
      cities: [],
      allCities: [],
      alphabet: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'ALL'],
    };
  },
  methods: {
    setBreadcrumbs() {
      this.breadcrumbs = [];

      if (this.$store.state.auth.mUser.role === 'admin') {
        this.breadcrumbs = this.breadcrumbs.concat([
          {
            text: 'Dashboard',
            href: '/admin',
            active: false,
          },
          {
            text: 'Content',
            active: true,
          },
        ]);
      } else if (this.$store.state.auth.mUser.role === 'editor') {
        this.breadcrumbs = this.breadcrumbs.concat([
          {
            text: 'Dashboard',
            href: '/admin',
            active: false,
          },
        ]);
      }

      this.breadcrumbs = this.breadcrumbs.concat([
        {
          text: 'Cities',
          href: '/cities',
          active: true,
        },
      ]);
    },
    filterCities(letter) {
      this.selectedLetter = letter;
      this.setCities();
    },
    setCities() {
      if (this.selectedLetter === 'ALL') {
        this.cities = this.allCities;
      } else {
        this.cities = this.allCities.filter((x) => x.name.startsWith(this.selectedLetter));
      }

      if (this.sortFunction) {
        this.cities = this.cities.sort(this.sortFunction);
      }
    },
    sortCities(sortProperty) {
      this.sortFunction = undefined;

      if (this.sortProperty === sortProperty) {
        // Toggle the sort order
        this.sortOrder *= -1;
      }

      this.sortProperty = sortProperty;

      if (sortProperty === 'name') {
        this.sortFunction = (a, b) => (a.name > b.name ? 1 : -1) * this.sortOrder;
      } else if (sortProperty === 'region') {
        this.sortFunction = (a, b) => (a.region > b.region ? 1 : -1) * this.sortOrder;
      } else if (sortProperty === 'type') {
        this.sortFunction = (a, b) => (a.city_type > b.city_type ? 1 : -1) * this.sortOrder;
      } else if (sortProperty === 'updated') {
        this.sortFunction = (a, b) => (new Date(a.updated_at).getTime() > new Date(b.updated_at).getTime() ? 1 : -1) * this.sortOrder;
      }

      this.setCities();
    },
    doesLetterHaveCities(letter) {
      if (letter === 'ALL') {
        return true;
      }

      const numCities = this.allCities.filter((x) => x.name.startsWith(letter)).length;

      return numCities > 0;
    },
    getCityTypeDisplay(type) {
      switch (type) {
        case 0:
          return 'Major';
        default:
          return 'Minor';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  margin-top: 7rem;
}

.city-container {
  margin-top: 2rem;
  background-color: white;
  padding: 2rem;
}
.title {
  margin: 0;
}

h1 {
  font-size: xx-large;
}

.clickable {
  cursor: pointer;
}

a:hover {
  text-decoration: none;
}

.city-filter {
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 0;
  li {
    display: inline-block;
    color: black;
    font-size: 1.25rem;
    margin-right: 0.5rem;
    cursor: pointer;
    pointer-events: all;

    &:hover,
    &.selected {
      text-decoration: underline;
    }

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}

.table thead th {
  border: none;
}

td {
  vertical-align: baseline;
}

table {
  border-collapse: collapse;
}
</style>
